import { Route } from '@angular/router';
import { GalleryComponent } from './gallery.component';
import { RouteAccess } from 'app/global/decorator/route-access.decorator';
import { DemoName } from 'app/demos/demo-name';

@RouteAccess({ demoName: DemoName.GALLERY_ENERGY_EFFICIENCY })
export class EnergyEfficiencyRoute implements Route {
    static path = 'energyEfficiency';
    static component = GalleryComponent;
    static data = { pageTitle: 'energyEfficiency.title' };
}
